import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import '../common/dialog.css';

/** @class NewContent
 * A component for choosing the type of content to
 * add to a Booth.
 */
export default class NewContentDialog extends Component {
  /** @function render
    * Renders the component
    */
  render(){
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}><FontAwesome name="times"/></button>
            </div>
            <div className="dialog-content">
              <div>
                <h3 className="header">New Content</h3>
                <p>Pick your content type:</p>
                <p className="hint">
                  <label htmlFor="title-content-radio">
                    <input type="radio"
                      id="title-content-radio"
                      onClick={()=>this.props.onChooseType("title")}
                      />
                    Title Content
                  </label>
                  Brief text
                </p>
                <p className="hint">
                  <label htmlFor="title-content-radio">
                    <input type="radio"
                      id="button-group-content-radio"
                      onClick={()=>this.props.onChooseType("button-group")}
                      />
                    Button Group Content
                  </label>
                  A grouping of buttons
                </p>
                <p className="hint">
                  <label htmlFor="rich-text-content-radio">
                    <input type="radio"
                      id="button-group-content-radio"
                      onClick={()=>this.props.onChooseType("rich-text")}
                      />
                    Rich Text Content
                  </label>
                  Text that can be styled
                </p>
                <p className="hint">
                  <label htmlFor="article-content-radio">
                    <input type="radio"
                      id="article-content-radio"
                      onClick={()=>this.props.onChooseType("article")}
                      />
                    Article Content
                  </label>
                  HTML-based content
                </p>
                <p className="hint">
                  <label htmlFor="image-content-radio">
                    <input type="radio"
                      id="image-content-radio"
                      onClick={()=>this.props.onChooseType("image")}
                      />
                    Image Content
                  </label>
                  A simple image
                </p>
                <p className="hint">
                  <label htmlFor="audio-content-radio">
                    <input type="radio"
                      id="audio-content-radio"
                      onClick={()=>this.props.onChooseType("audio")}
                      />
                    Audio Content
                  </label>
                  An embedded audio file (such as a podcast)
                </p>
                <p className="hint">
                  <label htmlFor="video-content-radio">
                    <input type="radio"
                      id="video-content-radio"
                      onClick={()=>this.props.onChooseType("video")}
                      />
                    Video Content
                  </label>
                  An embedded video
                </p>
                <p className="hint">
                  <label htmlFor="social-media-links-content-radio">
                    <input type="radio"
                      id="social-media-links-content-radio"
                      onClick={()=>this.props.onChooseType("social-media-links")}
                      />
                    Social Media Links Content
                  </label>
                  A collection of links to social media profiles
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/new-content-dialog.js